export enum InvitationStatus {
	pending,
	accepted,
	denied,
	blocked
}
